<template>
  <div class="container">


    <div class="form">
      <div class="img">
        <img src="../assets/images/bookservice1.png"></img>
      </div>
      <div class="output">
        <div class="item">
          <div class="title">您所在的区域 <span class="c_red">*</span></div>
          <div class="input" @click="addrClick">
          <span class="item-value c_no_pointer c_nowrap" :class="province?'':'c_gray'">
            {{(province == city ? province + district : province + city + district)||'请选择城市'}}
          </span>
          </div>
        </div>
        <div class="item">
          <div class="title">您的姓名（已加密请放心填写） <span class="c_red">*</span></div>
          <div class="input">
            <input type="text" placeholder="请在此填写" v-model="name">
          </div>
        </div>
        <div class="item">
          <div class="title">联系方式（已加密请放心填写） <span class="c_red">*</span></div>
          <div class="input" >
            <input type="text" placeholder="请在此填写" v-model="phone">
          </div>
        </div>
        <div class="check c_center">
          <input type="checkbox" value="true" readonly>自动输入历史手机号 <span class="c_blue">《个人信息授权书》</span>
        </div>
        <div class="opera" id="commitDiv">
          <div class="button" @click="saveOrderClick">立即预约上门勘察</div>
        </div>
        <div class="tips">
          温馨提示：屋顶材质为<span class="c_red">预制板</span>的暂时不提供维修服务，不承接<span class="c_red">水管漏水</span>维修服务，我们将会主动联系您，请注意接听陌生来电哦。
        </div>
        <div class="scroll">
          <div class="list">
            <van-swipe :duration="1000" :loop="true" :autoplay="1000" indicator-color="transparent" style="height: 20px;" vertical>
              <van-swipe-item v-for="(item,index) in scrollList" :key="index" >
                <div class="sub c_flex c_flex_between">
                  <div class="c_red">♥</div>
                  <div class="">已预约用户:杨**</div>
                  <div class="">184351146852</div>
                  <div class="">11小时前</div>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>

      </div>

      <div class="img">
        <img src="../assets/images/bookservice2.png"></img>
      </div>
    </div>


    <div class="c_p_t_10 c_hide">
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          客户姓名
        </div>
        <div class="item-content">
              <span class="item-value">
                <input type="text" placeholder="请填写客户姓名" v-model="name">
              </span>
          <!-- <span class="item-point">···</span> -->
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          客户手机号
        </div>
        <div class="item-content">
                <span class="item-value ">
                    <input type="number" placeholder="请填写客户手机号" v-model="phone">
                </span>
          <!-- <span class="item-point">···</span> -->
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white" @click="addrClick">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          所在区域
        </div>
        <div class="item-content">
                <span class="item-value c_no_pointer c_nowrap">
                    {{(province == city ? province + district : province + city + district)||'请选择详细地址'}}
                    <input type="hidden" placeholder="请选择省" v-model="province">
                    <input type="hidden" placeholder="请选择市" v-model="city">
                    <input type="hidden" placeholder="请选择区" v-model="district">
                </span>
          <!-- <span class="item-point">···</span> -->
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          详细地址
        </div>
        <div class="item-content c_flex c_flex_center">
              <span class="item-value" style="width:100%;">
                  <input type="text" placeholder="请填写详细地址" v-model="address">
              </span>
          <span class="item-point c_flex c_flex_center">
                <!--<i class="iconfont icon-bianjisekuai"></i>-->
              </span>
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white" @click="typeClick">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          房屋类型
        </div>
        <div class="item-content">
                <span class="item-value c_no_pointer">
                    <input type="text" placeholder="请选择房屋类型" v-model="type">
                </span>
          <!-- <span class="item-point">···</span> -->
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          渗漏部位
        </div>
        <div class="item-content">
                <span class="item-value">
                    <input type="text" placeholder="请填写渗漏部位" v-model="part">
                </span>
          <!-- <span class="item-point">···</span> -->
        </div>
      </div>

      <!--<div @click="saveOrderClick" class="item-save bg_blue c_center">确认下单</div>-->

    </div>

    <!--选择省市区-->
    <div class="model_addr" v-show="addr.isShow" >
      <div class="model-bg" @click="saveAddrClick"></div>
      <!--<mt-picker :slots="slots" :show-toolbar="addr.showtoolbar" value-key="name" @change="onValuesChange">-->
        <!--<div name="showToolbar" class="c_flex c_item_center c_flex_between">-->
          <!--<div></div>-->
          <!--<div class="model_save c_blue c_p_r_10" @click="saveAddrClick">-->
            <!--<i class="iconfont icon-duigou"></i>-->
          <!--</div>-->
        <!--</div>-->
      <!--</mt-picker>-->
      <div class="model-body">
        <div class="model-header c_flex c_flex_between c_item_center">
          <div class="model-title">城市地区选择</div>
          <div class="model-cancel" @click="saveAddrClick(true)">×</div>
        </div>
        <div class="model-hot" v-show="addr.hotList.length>0">
          <div class="model-hot-title">热门省市</div>
          <div class="model-hot-list c_flex">
            <div class="model-hot-group" v-for="(item,index) in addr.hotList" :key="index" :class="((addr.province==item.province)&&(addr.city==item.city))?'bg_red':''" >
              <div class="model-item c_flex c_flex_center" @click="hotClick(item)">
                {{item.name}}
              </div>
            </div>
          </div>
        </div>
        <div class="model-choose">
          <div class="model-hot-title">省市区选择</div>
          <div class="model-choose-title c_flex">
            <div :class="addr.province?'':'c_red'" @click="chooseAddress('province')">{{addr.province||'请选择'}}</div>
            <div v-show="addr.province" :class="addr.city?'':'c_red'" @click="chooseAddress('city')">{{addr.city||'请选择'}}</div>
            <div v-show="addr.province && addr.city" :class="addr.district?'':'c_red'" @click="chooseAddress('district')">{{addr.district||'请选择'}}</div>
          </div>
          <div class="model-choose-list">
            <div class="model-choose-group" :class="index % 2 ==0 ? 'bg-fcfcfc':'bg_white' " v-for="(item,index) in addr.chooseList" :key="index">
              <div class="model-item" :class="addr.chooseType=='province'?(item.name==addr.province?'c_red':''):(addr.chooseType=='city'?(item.name==addr.city?'c_red':''):(addr.district==item.name?'c_red':''))" @click="chooseClick(item)">
                {{item.name}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--选择房屋类型-->
    <mt-actionsheet
      :actions="type_params.actions"
      v-model="type_params.type_visible">
    </mt-actionsheet>

  </div>
</template>

<script>
  import { Toast } from 'mint-ui';
  var addressList = require('../comm/addressList.js');
  export default {
    name: "bookservice",
    data: function () {
      return {
        name: '',
        phone: '',
        type: '',
        source:'',
        province: '',
        city: '',
        district: '',
        address: '',
        part: '',
        addr: {
          chooseType:'province',
          province: '',
          city: '',
          district: '',
          hotList:[
            // {name:'北京',type:'district',province:'北京市',city:'北京市',district:''},
            // {name:'天津',type:'district',province:'天津市',city:'天津市',district:''},
            // {name:'四川',type:'city',province:'四川省',city:'',district:''},
            // {name:'陕西',type:'city',province:'陕西省',city:'',district:''},
            // {name:'武汉',type:'district',province:'湖北省',city:'武汉市',district:''},
            // {name:'上海',type:'district',province:'上海市',city:'上海市',district:''},
            // {name:'杭州',type:'district',province:'浙江省',city:'杭州市',district:''},
            // {name:'广州',type:'district',province:'广东省',city:'广州市',district:''},
          ],
          chooseList:[],
          provinceList: [],
          cityList: [],
          districtList: [],
          // showtoolbar:true,
          isShow:false,
        },
        type_params:{
          type_visible:false,
          actions:[
            {
              name: '平屋面/上人屋面',
              method : this.saveTypeClick,
            },
            {
              name: '平屋面/非上人屋面',
              method : this.saveTypeClick,
            },
            {
              name: '坡屋面/沥青瓦屋面',
              method : this.saveTypeClick,
            },
            {
              name: '坡屋面/水泥或陶瓷瓦屋面',
              method : this.saveTypeClick,
            },
            {
              name: '金属屋面/彩钢屋面',
              method : this.saveTypeClick,
            },
            {
              name: '金属屋面/阳光房',
              method : this.saveTypeClick,
            },
          ],
        },

        scrollList:[
          '','','',''
        ],

        servicebool:true,
      }
    },
    mounted: function () {
      let source = this.$route.query.source||'070102';
      if(source){
        this.source = source;
      }
      this.getProvinceList();
      let that = this;
      document.getElementById('commitDiv').addEventListener('click',function () {
        that.saveOrderClick();
      });

    },
    methods: {
      getProvinceList: function () {
        let addr = addressList.default.addressData;
        this.addr.province = this.province||'';
        this.addr.city = this.city||'';
        this.addr.district = this.district||'';
        this.addr.provinceList = addr;
        if(this.province){
          this.chooseAddress('district');
        }else{
          this.chooseAddress('province');
        }
      },
      // 选择省市区
      addrClick: function () {
        this.addr.isShow = true;
      },
      chooseAddress:function(type){
        if(type=='province'){
          this.addr.chooseList = this.addr.provinceList;
          this.addr.province = '';
          this.addr.city = '';
          this.addr.district = '';
          this.addr.cityList = [];
          this.addr.districtList = [];
        }else if(type == 'city' && this.addr.province){
          var provinceList = this.addr.provinceList;
          var cityList = [];
          for(let i=0,j=provinceList.length;i<j;i++){
            if(provinceList[i].name == this.addr.province){
              cityList = provinceList[i].child;
              break;
            }
          }
          this.addr.cityList = cityList;
          this.addr.city = '';
          this.addr.district = '';
          this.addr.districtList = [];
          this.addr.chooseList = cityList;
        }else if(type=='district' && this.addr.province && this.addr.city){
          var cityList = this.addr.cityList||[];
          if(cityList.length < 1){
            var provinceList = this.addr.provinceList;
            for(let i=0,j=provinceList.length;i<j;i++){
              if(provinceList[i].name == this.addr.province){
                cityList = provinceList[i].child;
                break;
              }
            }
          }
          var districtList = [];
          for(let ii=0,jj=cityList.length;ii<jj;ii++){
            if(cityList[ii].name == this.addr.city){
              districtList = cityList[ii].child;
              break;
            }
          }
          if(!this.addr.district){ this.addr.district = '';}
          this.addr.districtList = districtList;
          this.addr.chooseList = districtList;
        }
        this.addr.chooseType = type;
      },
      chooseClick:function(item){
        var chooseType = this.addr.chooseType;
        if(chooseType == 'province'){
          this.addr.province = item.name;
          this.addr.cityList = item.child;
          this.addr.chooseList = item.child;
          this.addr.chooseType = 'city';
        }else if(chooseType == 'city'){
          this.addr.city = item.name;
          this.addr.districtList = item.child;
          this.addr.chooseList = item.child;
          this.addr.chooseType = 'district';
        }else if(chooseType == 'district'){
          this.addr.district = item.name;
          this.saveAddrClick();
        }
      },

      hotClick:function(item){
        this.addr.province = item.province;
        this.addr.city = item.city;
        this.addr.district = item.district;
        this.addr.cityList = [];
        this.addr.districtList = [];
        this.addr.chooseType = item.type;
        this.chooseAddress(item.type);
      },
      saveAddrClick:function(bool){
        if(!bool){
          this.province = this.addr.province;
          this.city = this.addr.city;
          this.district = this.addr.district;
        }
        this.addr.isShow = false;
      },
      // 选择房屋类型
      typeClick:function(){
        this.type_params.type_visible = true;
      },
      saveTypeClick:function(obj){
        this.type = obj.name;
        console.log(obj.name);
      },
      // 保存
      saveOrderClick: function () {
        let $that = this;
        let obj = {};
        obj.name = this.name;
        obj.phone = this.phone;
        obj.province = this.province;
        obj.city = this.city;
        obj.district = this.district;
        // obj.address = this.address;
        // obj.part = this.part;
        if(!obj.name){ Toast({message: '请填写客户姓名',duration: 1500 }); return;}
        if(!obj.phone){ Toast({message: '请填写客户手机号',duration: 1500 }); return;}
        // if(!obj.address){ Toast({message: '请填写详细地址',duration: 1500 }); return;}
        // if(!obj.type){ Toast({message: '请选择房屋类型',duration: 1500 }); return;}
        // if(!obj.part){ Toast({message: '请填写渗漏部位',duration: 1500 }); return;}
        if(!this.servicebool)return;
        this.servicebool = false;
        console.log(this.$$api.mobile.saveCustomer);
        this.$ajax.post(this.$$api.mobile.saveCustomer,{
            customer:JSON.stringify(obj),
            source:this.source
        },function (res) {
          $that.$toast("成功");
          setTimeout(()=>{
            $that.servicebool = true;
          },1000)
        },function (res) {
          // $that.$toast("已添加");
        });
      },
      toBackClick:function () {
        // this.$router.go(-1);
      },

    },
    watch:{

    },

  }

</script>

<style scoped>
  .container {
    font-size: 4vw;
  }

  ::-webkit-input-placeholder {
    font-size: 3.5vw;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .item-group {
    width: 100%;
    box-sizing: border-box;
    word-wrap: break-word;
    padding: 3.226vw;
    display: flex;
    justify-content: space-between;
  }

  .item-title {
    width: 35%;
    text-align: left;
    height: 100%;

  }

  .item-content {
    width: 65%;
    text-align: right;
    font-size: 3.5vw;
    /*background: blue;*/
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .item-content input {
    font-size: 3.5vw;
  }

  .item-value {
    width: 90%;
    display: inline-block;
    height: 100%;
    padding: 0;
    margin: 0;
  }

  .item-value input {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    text-align: right;
    padding: 0;
    margin: 0;
    display: flex;
    align-content: center;
    /*background: red;*/
  }

  .product-title label {
    width: 100%;
    height: 100%;
    display: inline-block;
    display: flex;
    align-items: center;
  }

  .item-point i {
    font-size: .5rem;
  }

  .item-save {
    width: 25vw;
    color: #fff;
    height: 10.53vw;
    line-height: 10.53vw;
    font-size: 3.871vw;
    margin: auto;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
  }

  /*.model_addr*/
  .model_addr{
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 22;
    width: 100vw;
    height: 100vh;
  }
  .model-bg{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    z-index: 25;
  }

  .model_addr .model-body{
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 30;
    width: 100%;
    height: 65vh;
    background: #fff;
  }
  .model_addr .model-header{
    height: 6vh;
    padding: 0 5vw;
    border-bottom: .5px solid #ccc;
    font-size: 15px;
  }
  .model_addr .model-hot-title{
    font-size: 12px;
    color: #878787;
    padding: 3vw;
  }
  .model_addr .model-hot-list{
    padding:0 5vw;
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 14px;
    flex-wrap: wrap;
  }
  .model_addr .model-hot-group.bg_red{
    color: #fff;
    background: #dc1f31;
  }
  .model_addr .model-hot-group{
    padding: 2vw 5vw;
    background: #f2f2f2;
    border-radius: 5vw;
    margin-bottom: 2vw;
    margin-right: 3vw;
    overflow: hidden;
    text-overflow:ellipsis ;
    white-space: nowrap;
    flex-wrap:wrap;
  }
  .model_addr .model-choose-title{
    border-bottom: .5px solid #f2f2f2;
    box-sizing: border-box;
    width: 100%;
    padding: 0 5vw;
    font-size: 14px;
  }
  .model_addr .model-choose-title div.c_red{
    border-bottom: 1px solid #dc1f31;
    margin-bottom: 1px;
  }
  .model_addr .model-choose-title div{
    height: 8vw;
    max-width: 30vw;
    margin-right: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .model_addr .model-body,
  .model_addr .model-choose{
    display: flex;
    flex-direction:column;
  }
  .model_addr .model-choose{
    flex:1;
    overflow: auto;
  }
  .model_addr .model-choose-list{
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    /*height: calc( 100% - 30vh);*/
    /*height: 38vh;*/
    flex:1;
    overflow-x:hidden;
    overflow-y: auto;
  }
  .model_addr .model-choose-group{
    padding: 3vw 5vw;
    text-align: left;
  }
  .bg-fcfcfc{
    background: #fcfcfc;
  }


  /*//*/
  .form{
    box-sizing: border-box;
    width: 100%;
    background: #fff;
    margin-top: -9vh;
  }
  .form .img img{
    width: 100%;
    height: auto;
  }
  .form ::placeholder{
    font-size: 16px;
  }
  .form .output{
    padding: 10vw;
  }
  .form .item{
    font-size: 16px;
    margin-bottom: 7vw;
  }
  .form .item .input{
    width: 100%;
    border-bottom: 1px solid #ccc;
    margin-top: 5px;
    padding-bottom: 3px;
  }
  .form .item .input input{
    border: 0;
    outline: none;
    padding: 0;
  }

  .form .check{
    font-size: 14px;
  }
  .form .tips{
    font-size: 12px;
    color: #ccc;
  }
  .form .button{
    width: 65vw;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #3A3C40;
    color: #FFE371;
    border-radius: 13px;
    font-size: 22px;
    font-weight: bold;
    margin: 20px auto;
  }

  .form .scroll{
    font-size: 13px;
    margin-top: 20px;
  }
  .form .scroll .list{
    height: 25px;
    line-height: 25px;
    padding: 5px 10px;
    border-radius: 10px;
    box-shadow:1px 1px 7px -1px #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/components/bookserviceWx.vue